module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_bluepotion.0df260b1fa624ff23dab4475f861bf06.png";